import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseCreateProspectCustomerPayload } from 'src/app/models/customer/response-create-prospect-customer-payload';
import { PhoneNumberFormat } from 'src/app/models/customer/phone-number-format';
import { PostCustomerIndex } from 'src/app/models/customer/post-customer-index';
import { PostProspectCustomerCreate } from 'src/app/models/customer/post-prospect-customer-create';
import { SearchResultCustomerPayload } from 'src/app/models/customer/search-result-customer-payload';
import { CustomerLocationFieldRequirementsPayload } from 'src/app/models/customer-address/customer-location-field-requirements-payload';
import { SearchResultGenericCustomerAddressPayload } from 'src/app/models/customer-address/search-result-generic-customer-address-payload';
import { ReturnMessage } from 'src/app/models/return-message';
import { GenericSelectOptions } from 'src/app/models/shared/generic-select-options';
import { PostFilterFields } from 'src/app/models/shared/post-filter-fields';
import { CustomerTypeEnum } from 'src/app/models/customer/customer-type-enum';
import { ReturnGenericCustomerPayload } from 'src/app/models/customer/return-generic-customer-payload';
import { PostProspectCustomerUpdate } from 'src/app/models/customer/post-prospect-customer-update';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  private apis = {
    add: 'zmp_prospectCustomer/Create',
    update: 'zmp_prospectCustomer/Update',
    get: 'zmp_customer/Get/',
    getGeneric: 'mfqAppCustomer/Get/',
    getGenericAddresses: 'mfqAppCustomer/GetAddresses/',
    getAddresses: 'zmp_customer/GetAddresses/',
    nameSearch: 'mfqAppCustomer/Index/',
    getLabourRateGroupOptions: 'utility/GetLabourRateGroups/',
    getPriceMatrixOptions: 'utility/GetPriceMatrix/',
    getTaxSchedule: 'utility/GetTaxSchedule/',
    autocompleteMasterLocationGroup: 'utility/AutocompleteMasterLocationGroup/',
    customerLocationFieldRequirements: 'utility/GetCustomerAndLocationFieldRequirements/',
    getPhoneNumberFormat: 'utility/GetPhoneNumberFormat/',
    getTechnicians: 'utility/GetTechnicians'
  };

  constructor(
    private http: HttpClient) { }

  autocompleteMasterLocationGroup(data: PostFilterFields): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.autocompleteMasterLocationGroup, data);
  }

  getLaborRateGroupOptions(): Observable<ReturnMessage<GenericSelectOptions>> {
    return this.http.get<ReturnMessage<GenericSelectOptions>>(this.apis.getLabourRateGroupOptions);
  }

  getTaxSchedule(): Observable<ReturnMessage<GenericSelectOptions>> {
    return this.http.get<ReturnMessage<GenericSelectOptions>>(this.apis.getTaxSchedule);
  }

  getPriceMatrixOptions(): Observable<ReturnMessage<GenericSelectOptions>> {
    return this.http.get<ReturnMessage<GenericSelectOptions>>(this.apis.getPriceMatrixOptions);
  }


  add(data: PostProspectCustomerCreate): Observable<ReturnMessage<ResponseCreateProspectCustomerPayload>> {
    return this.http.post<ReturnMessage<ResponseCreateProspectCustomerPayload>>(this.apis.add, data);
  }

  update(data: PostProspectCustomerUpdate): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.update, data);
  }

  // get(id) {
  //   var params = { id: id };
  //   return this.http
  //     .get(this.apis.get, params)
  //     .map(this.extractData);
  // }

  getGeneric(id: string | number, type: string | CustomerTypeEnum): Observable<ReturnMessage<ReturnGenericCustomerPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
        .set('type', type)
    };
    return this.http.get<ReturnMessage<ReturnGenericCustomerPayload>>(this.apis.getGeneric, options);
  }


  // getAddresses(id) {
  //   var params = { id: id };
  //   return this.http
  //     .get(this.apis.getAddresses, params)
  //     .map(this.extractData);
  // }


  getGenericAddresses(id: string, type: string): Observable<ReturnMessage<SearchResultGenericCustomerAddressPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
        .set('type', type)
    };
    return this.http
      .get<ReturnMessage<SearchResultGenericCustomerAddressPayload>>(this.apis.getGenericAddresses, options);
  }

  getAllGenericAddresses(id: string | number, type: string): Observable<ReturnMessage<SearchResultGenericCustomerAddressPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
        .set('type', type)
    };
    const data = <PostFilterFields>{ noResultLimit: true };
    return this.http
      .post<ReturnMessage<SearchResultGenericCustomerAddressPayload>>(this.apis.getGenericAddresses, data, options);
  }

  searchGenericAddresses(id: string, type: string, data: PostFilterFields): Observable<ReturnMessage<SearchResultGenericCustomerAddressPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
        .set('type', type)
    };
    return this.http.post<ReturnMessage<SearchResultGenericCustomerAddressPayload>>(this.apis.getGenericAddresses, data, options);
  }

  nameSearch(data: PostCustomerIndex): Observable<ReturnMessage<SearchResultCustomerPayload>> {
    return this.http.post<ReturnMessage<SearchResultCustomerPayload>>(this.apis.nameSearch, data);
  }

  getCustomerLocationFieldRequirements(): Observable<ReturnMessage<CustomerLocationFieldRequirementsPayload>> {
    return this.http.get<ReturnMessage<CustomerLocationFieldRequirementsPayload>>(this.apis.customerLocationFieldRequirements);
  }

  getPhoneNumberFormat(): Observable<ReturnMessage<PhoneNumberFormat>> {
    return this.http.get<ReturnMessage<PhoneNumberFormat>>(this.apis.getPhoneNumberFormat);
  }

  getTechnicians(): Observable<ReturnMessage<GenericSelectOptions>> {
    return this.http.get<ReturnMessage<GenericSelectOptions>>(this.apis.getTechnicians);
  }
}
